<template>
  <v-layout column class="pt-1" data-qa="transferinstatus-layout-geau5">
    <v-flex v-for="(item,i) in transferInData" :key="i" :data-qa="`transferinstatus-flex-s2vmp-${i}`">
      <v-flex xs12 sm12 md7 lg7 xl7 class="ml-5" :data-qa="`transferinstatus-flex-nedtl-${i}`">
        <v-card class="text-left" :data-qa="`transferinstatus-card-1h4s1-${i}`">
          <v-list-item @click="selectedTransfer(item)" two-line :data-qa="`transferinstatus-list-item-dcazuc-${i}`">
            <v-list-item-content :data-qa="`transferinstatus-list-item-content-to8xfs-${i}`">
                <div class="overline mb-0" :data-qa="`transferinstatus-div-e6e997-${i}`">
                  <font class="subtitle-1 font-weight-normal ml-2">{{ $t("lisaAccountDetails.transferInManager") }} <font :color="getColor(item.status)">{{ item.lisamanagerRefno }}</font></font>
                </div>
                <div class="overline mb-0" :data-qa="`transferinstatus-div-vklw4a-${i}`">
                  <font class="subtitle-1 font-weight-normal ml-2">{{ $t("lisaAccountDetails.transferInAccount") }} {{ item.existingLISAno }}</font>
                </div>
            </v-list-item-content>
            <v-icon class="text-end" :data-qa="`transferinstatus-icon-oajbwk-${i}`">mdi-chevron-right</v-icon>
          </v-list-item>
          <v-divider :data-qa="`transferinstatus-divider-7d74em-${i}`"></v-divider>
        </v-card>
      </v-flex>
      <Modal
        :config="modalConfig"
        @btn1Action="modalConfig.enabled = false">
        <span slot="modalContent" :data-qa="`transferinstatus-span-f78zwg-${i}`">
          <v-row no-gutters class="pl-6" :data-qa="`transferinstatus-row-qyb1rh-${i}`">
            <v-col cols="6" class="px-6 pt-0 pl-0" :data-qa="`transferinstatus-col-h5m2ed-${i}`">
              <div class="text-uppercase pa-1 overline font-weight-bold" :data-qa="`transferinstatus-div-tsfz7v-${i}`">
                {{ $t("lisaAccountDetails.lisaManager") }}
              </div>
              <div class="pb-3 pa-1" :data-qa="`transferinstatus-div-d4zsp-${i}`">
                {{ selectedItem.lisamanagerRefno }}
              </div>
            </v-col>
            <v-col cols="6" class="px-6 pr-0 pt-0" :data-qa="`transferinstatus-col-bnx66-${i}`">
              <div class="text-uppercase pa-1 overline font-weight-bold" :data-qa="`transferinstatus-div-k9pjk-${i}`">
                {{ $t("lisaAccountDetails.lisaAccount") }}
              </div>
              <div class="pb-3 pa-1" :data-qa="`transferinstatus-div-v7bk4-${i}`">
                {{ selectedItem.existingLISAno }}
              </div>
            </v-col>
            <v-col cols="6" class="px-6 pl-0 pt-0" :data-qa="`transferinstatus-col-1zn5dd-${i}`">
              <div class="pa-1 overline font-weight-bold" :data-qa="`transferinstatus-div-8i2xl-${i}`">
                {{ $t("lisaAccountDetails.lisaCurrTaxSubscription") }}
              </div>
              <div class="pb-3 pa-1" :data-qa="`transferinstatus-div-w1qbv-${i}`">
                {{$formatter.currency.format(selectedItem.currenttaxyearAmount)}}
              </div>
            </v-col>
            <v-col cols="6" class="px-6 pr-0 pt-0" :data-qa="`transferinstatus-col-5zorw02-${i}`">
              <div class="pa-1 overline font-weight-bold" :data-qa="`transferinstatus-div-u49wb5-${i}`">
                {{ $t("lisaAccountDetails.lisaPrevTaxSubscription") }}
              </div>
              <div class="pb-3 pa-1" :data-qa="`transferinstatus-div-oi2o3q-${i}`">
                {{ $formatter.currency.format(selectedItem.previoustaxyearAmount)}}
              </div>
            </v-col>
            <v-col cols="6" class="px-6 pl-0 pt-0" :data-qa="`transferinstatus-col-078xlm-${i}`">
              <div class="pa-1 overline font-weight-bold" :data-qa="`transferinstatus-div-otevs7-${i}`">
                {{ $t("lisaAccountDetails.transferInStatus") }}
              </div>
              <div class="pb-3 pa-1" :data-qa="`transferinstatus-div-1igxx-${i}`">
                <font :color="getColor(selectedItem.status)">{{ selectedItem.status }}</font>
              </div>
            </v-col>
          </v-row>
        </span>
      </Modal>
    </v-flex>
  </v-layout>
</template>

<script>
import Modal from '@/components/common/Modal.vue'
export default {
  components: { Modal },
  name: 'TransferInStatus',
  props: {
    config: Array
  },
  data () {
    return {
      transferInData: {},
      selectedItem: {},
      modalConfig: {
        enabled: false,
        persistent: true,
        btn1Label: this.$t('lisaAccountDetails.back'),
        title: this.$t('lisaAccountDetails.transferInDetailsLabel'),
        width: 800
      }
    }
  },
  created () {
    this.transferInData = this.config
  },
  methods: {
    getColor (status) {
      switch (status) {
        case 'PENDING': return '#F4BC1C'
        case 'PROCESSED': return 'green'
        case 'REJECTED': return 'red'
        default:
      }
    },
    selectedTransfer (item) {
      this.selectedItem = item
      this.modalConfig.enabled = true
    }
  }
}
</script>
<style lang="scss" scoped>
.status{
&--hover {
cursor: pointer;
}
}
</style>
